module.exports = __webpack_public_path__ + "img/fitted-mask-string-ties-hero.da11daea.jpg";